import { MyProjectsStateType } from './MyProjectsInitialState.types'

export const MyProjectsInitialState: MyProjectsStateType = {
  userProjects: []
}
